"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const types_1 = require("src/types");
const layout_1 = require("src/hooks/layout");
const modal_1 = require("src/context/modal");
const branding_1 = require("src/context/branding");
const plug_styles_1 = __importDefault(require("./plug.styles"));
const b = b_1.default.with('plug');
function Plug({ current = 0, max }) {
    const context = (0, modal_1.useModalContext)();
    const isMobile = (0, layout_1.useIsMobile)();
    const isMorda = (context === null || context === void 0 ? void 0 : context.surveyPreset) === types_1.SurveyPreset.YandexMorda;
    const { input: { restriction: { hidden = isMorda } = {}, mobile: { restriction: { hidden: mobileHidden = hidden } = {} } = {} } = {} } = (0, branding_1.useBrandingContext)() || {};
    if ((isMobile ? mobileHidden : hidden) || !max)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: plug_styles_1.default, className: b() }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: b('counter', {
                    lengthExceeds: current > max
                }) }, { children: current })), "/", max] })));
}
exports.default = Plug;
